import { useEffect } from 'react'
import { ThrottleTimers } from '../../../types/state'
import { registerTimer, unregisterTimer } from '../../state/state.timers'
import { useSyncedRef } from './useSyncedRef'

const useInterval = (
    key: keyof ThrottleTimers['timers'],
    callback: () => void,
    delay: number,
    halt?: boolean,
) => {
    const savedCallback = useSyncedRef(callback)

    const stopInterval = () => {
        unregisterTimer(key)
    }

    // Set up the interval.
    useEffect(() => {
        if (halt) {
            unregisterTimer(key)
            return
        }

        // Don't schedule if no delay is specified. Note: 0 is a valid value for delay.
        if (!delay && delay !== 0) {
            return
        }

        const tick = () => {
            savedCallback.current()
        }

        registerTimer(key, tick, delay)
        return stopInterval
    }, [delay, halt])

    return stopInterval
}

export default useInterval
